module.exports = __webpack_public_path__ + "static/img/qywh_banner@2x.124f852.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/qywh_banner@2x.png
// module id = E+pE
// module chunks = 0